import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { showErrorMessage } from './utils';

export const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      meta: {
        skipGlobalErrorToaster: false,
      },
    },
    queries: {
      meta: {
        skipGlobalErrorToaster: false,
      },
    },
  },
  mutationCache: new MutationCache({
    onError(error, _variables, _context, mutation) {
      const skipGlobalErrorToaster = mutation?.options?.meta?.skipGlobalErrorToaster;

      if (error && !skipGlobalErrorToaster) {
        showErrorMessage({ message: error?.response?.data?.error || error?.message });
      }
    },
  }),
  queryCache: new QueryCache({
    onError(error, query) {
      const skipGlobalErrorToaster = query?.options?.meta?.skipGlobalErrorToaster;

      if (error && !skipGlobalErrorToaster) {
        showErrorMessage({ message: error?.response?.data?.error || error?.message });
      }
    },
  }),
});
